import React from 'react';
import {
  Identifier,
  Link,
  List,
  Datagrid,
  RaRecord,
  RowClickFunction,
  TextField,
  useRedirect,
} from 'react-admin';
import { Button, Typography } from '@mui/material';

import { Manager } from '@types';
import { BooleanField, PhoneField } from '@components';
import cls from './IndividualManagers.module.css';

export const IndividualManagers = ({ manager }: {manager: Manager}) => {
  const redirect = useRedirect();

  if (!manager) {
    return (<></>);
  }

  const rowClick: RowClickFunction = (id: Identifier, resource: string, record: RaRecord) => {
    if (record.type === 'buyer') {
      redirect(`/manager/${id}`);
    } else if (record.type === 'retailer') {
      redirect(`/manager-retailer/${id}`);
    } else if (record.type === 'associate') {
      redirect(`/manager-associate/${id}`);
    }
    return false;
  };

  return (
    <div className={cls.box}>
      <div className={cls.header}>
        <Typography variant="h6" component="h2" className={cls.subTitle}>
          Individuals managers
        </Typography>
        <Link to={`/manager-associate/create?dealerId=${manager.dealerId}`}>
          <Button
            className={cls.btnAdd}
            variant="contained"
            color="secondary"
          >+</Button>
        </Link>
      </div>

      {manager && (
        <List
          resource={`manager/${manager.id}/individual-managers`}
          exporter={false}
          actions={false}
          className={cls.list}
          title={' '}
          empty={<div />}
        >
          <Datagrid rowClick={rowClick}>
            <TextField source="name" />
            <PhoneField source="phone" />
            <TextField source="email" />
            <TextField source="position" />
            <BooleanField source="isEnabled" />
          </Datagrid>
        </List>
      )}
    </div>
  );
};
